import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage as HookFormErrorMessage } from '@hookform/error-message';
import { bem } from 'helpers/class-name';

import './ErrorMessage.scss';

const { block } = bem('hook-form-error');

export const errorMessageId = name => `${name}-error`;

function ErrorMessage(props) {
  const { name, className, errors, id } = props;

  return (
    <HookFormErrorMessage
      errors={errors}
      name={name}
      render={({ message: errorMessage }) => (
        <div className={block(className)} id={id} data-cypress="form-field-error">
          {errorMessage}
        </div>
      )}
    />
  );
}

ErrorMessage.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  errors: PropTypes.shape({}),
};

export default ErrorMessage;
